import { Edit as EditIcon } from "@mui/icons-material"
import ErrorBoundary from '../../ErrorBoundary'

const PaymentSummaryCard = ({ subscription, onAction }) => {
	return (
		<div className="scout-settings-card scout-payments-summary-card">
			<div className="scout-payments-summary-card__header">
				<div className="scout-payments-summary-card__meta">
					<strong>{subscription?.name}</strong>
					<span>{subscription?.details}</span>
				</div>
				<div className="scout-payments-summary-card__price-block">
					<strong>{subscription?.price}</strong>
					<span>{subscription?.renewalLabel}</span>
				</div>
				<button
					type="button"
					className="scout-payments-summary-card__action"
					onClick={() => onAction?.(subscription?.primaryAction)}
				>
					<EditIcon fontSize="small" />
					<span className="scout-payments-action-label--desktop">{subscription?.primaryAction?.label}</span>
					<span className="scout-payments-action-label--mobile">{subscription?.primaryAction?.mobileLabel ?? subscription?.primaryAction?.label}</span>
				</button>
			</div>
		</div>
	)
}

const PaymentSummaryCardWithBoundary = (props) => (
    <ErrorBoundary
        componentName="PaymentSummaryCard"
        showReload
        logToBackend
        title="Erro no resumo da assinatura"
        message="Ocorreu um erro ao carregar os dados da sua assinatura. Tente novamente."
    >
        <PaymentSummaryCard {...props} />
    </ErrorBoundary>
)

export default PaymentSummaryCardWithBoundary